import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BoxDiv } from "../../Miscellaneous/FancyDiv.component";
import {
  profileDb,
  educationDb,
  awardsDb,
  academicPositionsDb,
} from "../../../db/dbClasses";
import AcademicPositions from "./AcademicPositions.component";
import AwardsList from "./AwardsList.component";
import Education from "./Education.component";
import "./Profile.scss";

const ProfileTextBlock = (props) => {
  return (
    <React.Fragment>
      <div className="w-100 p-3 pt-0">
        <div className="w-100 mx-auto p-2 pt-0 mb-2 border-bottom">
          <span className="font-open-sans fw-l text-black-50 fw-b display-6">
            {props.first_name && (
              <span>
                Dr. {props.first_name} {props.last_name}
              </span>
            )}
          </span>
        </div>
        <p
          className="fw-l"
          style={{
            fontSize: "1.6rem",
          }}
        >
          {/* This is HARD-CODED. */}
          PhD (Windsor), MSc (Alberta)
        </p>
        <p className="fw-l" style={{ fontSize: "1.5rem", marginTop: "-20px" }}>
          {props.position}
        </p>
        <div
          style={{
            whiteSpace: "pre-wrap",
          }}
        >
          {props.description}
        </div>
      </div>
    </React.Fragment>
  );
};

const getAllData = async () => {
  const profile = await profileDb.read();
  const degrees = await educationDb.read();
  const awards = await awardsDb.read();
  const positions = await academicPositionsDb.read();

  return Promise.resolve({
    profile: profile[0],
    degrees,
    awards,
    positions,
  });
};

const yearComparator = (a, b, reverse = true) => {
  try {
    const aYear = Number.parseInt(a.completion_year);
    const bYear = Number.parseInt(b.completion_year);
    const aMonth = Number.parseInt(a.completion_month);
    const bMonth = Number.parseInt(b.completion_month);

    if (aYear === bYear) {
      if (reverse) return bMonth - aMonth;
      return aMonth - bMonth;
    }
    if (reverse) return bYear - aYear;
    return aYear - bYear;
  } catch (err) {
    return 0;
  }
};

const Profile = (props) => {
  const [degrees, setDegrees] = useState([]);
  const [profileObject, setProfileObject] = useState({});
  const [awards, setAwards] = useState([]);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    getAllData().then((res) => {
      setDegrees(res.degrees);
      setProfileObject(res.profile);
      setAwards(res.awards);
      setPositions(res.positions);
    });
  }, []);

  return (
    <div>
      <div className="p-0">
        <Row>
          <Col
            xl={5}
            className="p-5 d-flex align-items-center justify-content-center"
          >
            <Row>
              <Col
                xs={12}
                className="justify-content-center align-items-center"
              >
                <img
                  src={profileObject?.photo}
                  alt="profile"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                  }}
                  id="home"
                  className="rounded"
                />
                {profileObject?.cv_link && (
                  <a href={profileObject.cv_link}>
                    <button
                      className="mt-3 mx-auto d-flex align-items-center justify-content-center flex-column font-open-sans fw-n button-modern"
                      style={{
                        width: "180px",
                        height: "50px",
                      }}
                    >
                      Curriculum Vitae
                    </button>
                  </a>
                )}
              </Col>
            </Row>
          </Col>
          <Col
            xl={7}
            className="font-open-sans d-flex align-items-center justify-content-start flex-column pt-5"
          >
            <ProfileTextBlock {...profileObject} />
          </Col>
        </Row>
      </div>

      <BoxDiv>
        <Row>
          <Col
            xl={6}
            className="d-flex align-items-start justify-content-center"
          >
            <AcademicPositions positions={positions} />
          </Col>
          <Col
            xl={6}
            className="d-flex align-items-start justify-content-center"
          >
            <Education cleanDegrees={[...degrees].sort(yearComparator)} />
          </Col>
        </Row>
      </BoxDiv>
      <div className="p-5">
        <div className="w-80 mx-auto p-2 mb-5 border-bottom text-center">
          <h3 className="font-open-sans fw-l">Awards and Honors</h3>
        </div>
        <AwardsList bgColor={props.bgColor} awards={awards} />
      </div>
    </div>
  );
};

export default Profile;
